import {
	existsSync,
	mkdirSync,
	mkdtempSync,
	rmSync,
	writeFileSync,
} from "node:fs";
import { homedir, tmpdir } from "node:os";
import { dirname, join } from "node:path";
import shippedSkills from "../api/shipped-skills.json" with { type: "json" };

/**
 * Writes the bundled skill tree to a real directory incur can glob.
 * Standalone binaries and npx runs have no skills/ directory on disk — the
 * package root resolves inside bun's virtual filesystem (or an ephemeral npx
 * cache), so `sync.include` globs against loose package files find nothing.
 *
 * incur's include path only copies each skill's SKILL.md into its install
 * staging dir, so playbook files (`references/*`) are written onto the
 * installed skill after sync via `overlayShippedSkillFiles`.
 */
export function materializeShippedSkills(): string {
	const root = mkdtempSync(join(tmpdir(), "whop-cli-skills-"));
	for (const [name, files] of Object.entries(shippedSkills)) {
		writeSkillFiles(join(root, name), files);
	}
	process.on("exit", () => {
		overlayShippedSkillFiles();
		rmSync(root, { recursive: true, force: true });
	});
	return root;
}

function overlayShippedSkillFiles() {
	if (!process.argv.includes("add")) return;
	const destRoot = process.argv.includes("--no-global")
		? join(process.cwd(), ".agents", "skills")
		: join(homedir(), ".agents", "skills");
	for (const [name, files] of Object.entries(shippedSkills)) {
		const skillDir = join(destRoot, name);
		if (!existsSync(join(skillDir, "SKILL.md"))) continue;
		writeSkillFiles(skillDir, files, { skip: ["SKILL.md"] });
	}
}

function writeSkillFiles(
	root: string,
	files: Record<string, string>,
	options: { skip?: string[] } = {},
) {
	const skip = new Set(options.skip ?? []);
	for (const [rel, content] of Object.entries(files)) {
		if (rel.includes("..") || rel.startsWith("/")) {
			throw new Error(`Refusing to materialize skill path ${rel}`);
		}
		if (skip.has(rel)) continue;
		const dest = join(root, ...rel.split("/"));
		mkdirSync(dirname(dest), { recursive: true });
		writeFileSync(dest, content);
	}
}
